/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const PinFilled = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path
        className="st0"
        d="M16.9,5.2l-4.1-4.1c0,0-0.1-0.1-0.1-0.1c-0.7-0.5-1.6-0.4-2.1,0.3L6.6,6.5C5,6.4,3.3,6.9,2.2,8.1C2,8.3,2,8.6,2.2,8.8L5.4,12l-3.2,3.2c-0.5,0.5,0.2,1.2,0.7,0.7l3.2-3.2l3.2,3.2c0.2,0.2,0.5,0.2,0.7,0c1.2-1.2,1.7-2.8,1.6-4.4l5.2-4.1c0,0,0.1-0.1,0.1-0.1C17.5,6.7,17.5,5.7,16.9,5.2z"
      />
    </BaseSvgIcon>
  )
}

export default PinFilled
